module.exports = __webpack_public_path__ + "img/mizutamari-cut-03.65b34d5e.jpg";